import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/teams/events.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getTeamEvents = (_0) => __async(null, [_0], function* ({
  lang,
  page,
  perPage,
  organizationSlug,
  teamId,
  status = "upcoming"
}) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const search = new URLSearchParams();
    search.set("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    search.set("lang", locale);
    if (page) {
      search.append("page", page.toString());
    }
    if (perPage) {
      search.append("per_page", perPage.toString());
    }
    if (status) search.append("status", status);
    const data = yield fetchClient({
      url: `/team-events/${teamId}?${organizationSlug}&${search.toString()}`,
      includeAuth: false
    });
    return data;
  } catch (error) {
    throw new Exception({ error, name: "getTeamEventsException" });
  }
});

export {
  getTeamEvents
};
//# sourceMappingURL=chunk-5US3DELL.mjs.map